import api from "@/plugins/axios";

export const getAll = async () => {
  const response = await api.get("/participacion");
  return response.data;
};

export const getAllEmpresa = async (id) => {
  const params = {};
  params.id = id ?? null;
  const response = await api.get("/participacion", { params });
  return response.data;
};

export const getById = async (id) => {
  const response = await api.get(`/participacion/${id}`);
  return response.data;
};

export const getByEmpresaEvento = async (idEmpresa, idEvento) => {
  try {
    const response = await api.get(`/participacion/buscar`, {
      params: { idEmpresa, idEvento },
    });
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      // Participación no encontrada, se interpreta como "no existe"
      return null;
    } else {
      // Otro tipo de error, se relanza
      throw error;
    }
  }
};

export const create = async (data) => {
  const response = await api.post("/participacion", data);
  return response.data;
};

export const update = async (id, data) => {
  const response = await api.put(`/participacion/${id}`, data);
  return response.data;
};

export const remove = async (id) => {
  await api.delete(`/participacion/${id}`);
};
